import * as React from 'react';

const Italic = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.33333 5H11.6667M11.6667 5H15M11.6667 5L8.33333 15M8.33333 15H11.6667M8.33333 15H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default Italic;
